import CloseIcon from "@mui/icons-material/Close";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import type React from "react";
import { useEffect } from "react";

interface SearchBoxLocalProps {
  onSearch: (query: string) => void;
  placeHolderText?: string;
  width?: string;
  height?: string;
  borderRadius?: string;
  total?: number;
  loading?: boolean;
  query: string;
  setQuery: (value: string) => void;
}

export const SearchBoxLocal: React.FC<SearchBoxLocalProps> = ({
  width = "100%",
  height = "40px",
  placeHolderText = "Search...",
  borderRadius = "4px",
  total = 0,
  onSearch,
  loading,
  query,
  setQuery,
}) => {
  const handleSearch = () => {
    if (total > 500) return; // Disable search if total > 500
    onSearch(query);
  };

  const handleClearSearch = () => {
    setQuery("");
    onSearch("");
  };

  const fontSize = `${loading || total > 500 ? "11px !important" : "1rem"}`;
  const textTop = `${loading || total > 500 ? "-2px" : "-6px"}`;
  const bgColor = `${loading || total > 500 ? "inherit" : "#fff"}`;

  useEffect(() => {
    if (total > 500 || loading) {
      setQuery("");
    }
  }, [total]);

  return (
    <TextField
      sx={{
        ">.MuiInputBase-root.MuiInputBase-formControl": {
          color: "rgba(0, 0, 0, 0.6)",
          fontFamily: "AGRegular",
          backgroundColor: bgColor,
          "&:hover": { borderColor: "inherit" },
        },
        ">label.MuiFormLabel-root.MuiInputLabel-root": {
          fontSize: fontSize,
          top: textTop,
        },
      }}
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      onKeyDown={(e) => e.key === "Enter" && handleSearch()}
      onBlur={handleSearch}
      label={placeHolderText}
      fullWidth
      disabled={loading || total > 500}
      InputProps={{
        style: { width, height, borderRadius, fontSize },
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={handleClearSearch}
              disabled={loading || total > 500}
            >
              {query.length > 0 && <CloseIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
